<script>
export default {
  methods: {
    filterImgSizes: function (sizes) {
      if (sizes instanceof Object && sizes !== null) {
        var keys = Object.keys(sizes), nk = keys.length, i = 0, k;
        for (; i < nk; i++) {
          k = keys[i]
          if (sizes[k].indexOf('/') === 0) {
            sizes[k] = this.$parent.mediabase + sizes[k].replace(/^\//,'')
          }
        }
      }
      return sizes
    }
  }
}
</script>


// WEBPACK FOOTER //
// ImageManager.vue?686542e5